import type { Direction, Locale } from '../types';

import enCommon from './en-AE/common.json';
import enErrors from './en-AE/errors.json';
import enOnboarding from './en-AE/onboarding.json';
import enInvoice from './en-AE/invoice.json';
import enInvoiceDetail from './en-AE/invoiceDetail.json';
import enInbox from './en-AE/inbox.json';
import enApprovals from './en-AE/approvals.json';
import enArchive from './en-AE/archive.json';
import enCompliance from './en-AE/compliance.json';
import enTemplates from './en-AE/templates.json';
import enSettings from './en-AE/settings.json';
import enNotifications from './en-AE/notifications.json';
import enDashboard from './en-AE/dashboard.json';
import enAdmin from './en-AE/admin.json';
import enTickstar from './en-AE/tickstar.json';
import enGlossary from './en-AE/glossary.json';
import enLogin from './en-AE/login.json';
import enP1 from './en-AE/p1.json';

import arCommon from './ar-AE/common.json';
import arErrors from './ar-AE/errors.json';
import arOnboarding from './ar-AE/onboarding.json';
import arInvoice from './ar-AE/invoice.json';
import arInvoiceDetail from './ar-AE/invoiceDetail.json';
import arInbox from './ar-AE/inbox.json';
import arApprovals from './ar-AE/approvals.json';
import arArchive from './ar-AE/archive.json';
import arCompliance from './ar-AE/compliance.json';
import arTemplates from './ar-AE/templates.json';
import arSettings from './ar-AE/settings.json';
import arNotifications from './ar-AE/notifications.json';
import arDashboard from './ar-AE/dashboard.json';
import arAdmin from './ar-AE/admin.json';
import arTickstar from './ar-AE/tickstar.json';
import arGlossary from './ar-AE/glossary.json';
import arLogin from './ar-AE/login.json';
import arP1 from './ar-AE/p1.json';

import huCommon from './hu-HU/common.json';
import huErrors from './hu-HU/errors.json';
import huOnboarding from './hu-HU/onboarding.json';
import huInvoice from './hu-HU/invoice.json';
import huInvoiceDetail from './hu-HU/invoiceDetail.json';
import huInbox from './hu-HU/inbox.json';
import huApprovals from './hu-HU/approvals.json';
import huArchive from './hu-HU/archive.json';
import huCompliance from './hu-HU/compliance.json';
import huTemplates from './hu-HU/templates.json';
import huSettings from './hu-HU/settings.json';
import huNotifications from './hu-HU/notifications.json';
import huDashboard from './hu-HU/dashboard.json';
import huAdmin from './hu-HU/admin.json';
import huTickstar from './hu-HU/tickstar.json';
import huGlossary from './hu-HU/glossary.json';
import huLogin from './hu-HU/login.json';
import huP1 from './hu-HU/p1.json';

export const SUPPORTED_LOCALES: Locale[] = ['en-AE', 'ar-AE', 'hu-HU'];
export const DEFAULT_LOCALE: Locale = 'en-AE';

export const LOCALE_LABELS: Record<Locale, string> = {
  'en-AE': 'English',
  'ar-AE': 'العربية',
  'hu-HU': 'Magyar',
};

export const DIRECTION_OF: Record<Locale, Direction> = {
  'en-AE': 'ltr',
  'ar-AE': 'rtl',
  'hu-HU': 'ltr',
};

export const RESOURCES = {
  'en-AE': {
    common: enCommon,
    errors: enErrors,
    onboarding: enOnboarding,
    invoice: enInvoice,
    invoiceDetail: enInvoiceDetail,
    inbox: enInbox,
    approvals: enApprovals,
    archive: enArchive,
    compliance: enCompliance,
    templates: enTemplates,
    settings: enSettings,
    notifications: enNotifications,
    dashboard: enDashboard,
    admin: enAdmin,
    tickstar: enTickstar,
    glossary: enGlossary,
    login: enLogin,
    p1: enP1,
  },
  'ar-AE': {
    common: arCommon,
    errors: arErrors,
    onboarding: arOnboarding,
    invoice: arInvoice,
    invoiceDetail: arInvoiceDetail,
    inbox: arInbox,
    approvals: arApprovals,
    archive: arArchive,
    compliance: arCompliance,
    templates: arTemplates,
    settings: arSettings,
    notifications: arNotifications,
    dashboard: arDashboard,
    admin: arAdmin,
    tickstar: arTickstar,
    glossary: arGlossary,
    login: arLogin,
    p1: arP1,
  },
  'hu-HU': {
    common: huCommon,
    errors: huErrors,
    onboarding: huOnboarding,
    invoice: huInvoice,
    invoiceDetail: huInvoiceDetail,
    inbox: huInbox,
    approvals: huApprovals,
    archive: huArchive,
    compliance: huCompliance,
    templates: huTemplates,
    settings: huSettings,
    notifications: huNotifications,
    dashboard: huDashboard,
    admin: huAdmin,
    tickstar: huTickstar,
    glossary: huGlossary,
    login: huLogin,
    p1: huP1,
  },
} as const;
